import type { GeneratedExamPaper } from './generated';

// ─── History ──────────────────────────────────────────────────────────────────

export interface HistoryEntry {
  id: string;
  generatedAt: string;
  subject: string;
  subjectCode: string;
  department: string;
  classLevel: number;
  examType: 'written' | 'mcq';
  numberOfQuestions: number;
  totalMarks: number;
  difficulty: string;
  chapters: string[];
  tokenUsage: {
    promptTokens: number;
    completionTokens: number;
    totalTokens: number;
  };
  examPaper: GeneratedExamPaper;
}

// ─── Leaderboard ──────────────────────────────────────────────────────────────

export interface LeaderboardEntry {
  rank: number;
  name: string;
  totalQuestions: number;
  isCurrentUser?: boolean;
}

// ─── Static labels ────────────────────────────────────────────────────────────

export const DEPARTMENT_LABELS: Record<string, string> = {
  science: 'বিজ্ঞান / Science',
  commerce: 'বাণিজ্য / Commerce',
  arts: 'মানবিক / Arts',
};
